import React, { useState } from "react";

export const withToggle = (WrapperComponent) => {
  const WithToggleComponent = (props) => {
    const [isToggle, setIsToggle] = useState(false);
    const toggleShowModal = () => setIsToggle(!isToggle);
    const toggleHideModal = () => setIsToggle(false);
    return (
      <WrapperComponent
        {...props}
        isToggle={isToggle}
        toggleShowModal={toggleShowModal}
        toggleHideModal={toggleHideModal}
      />
    );
  };
  return WithToggleComponent;
};

export default withToggle;
